import React from 'react';
import { AesSeverity } from 'api/AesAnalyzerAPI';

export const AES_SEVERITY_LABEL: Record<AesSeverity, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  informational: 'Informational',
};

/** Short form used inside a flag chip, next to the flag name. */
const AES_SEVERITY_TAG: Record<AesSeverity, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  informational: 'Info',
};

export const AES_SEVERITY_ORDER: AesSeverity[] = [
  'critical',
  'high',
  'medium',
  'low',
  'informational',
];

interface IAesSeverityChipProps {
  severity: AesSeverity;
  /** The flag name. Without one, the chip shows just the severity. */
  label?: React.ReactNode;
  cleared?: boolean;
  title?: string;
}

/**
 * Severity-colored pill. With a label it reads "High · Late EEI Filing": the
 * severity and the flag name, never the internal rule id.
 */
const AesSeverityChip: React.FC<IAesSeverityChipProps> = ({
  severity,
  label,
  cleared,
  title,
}) => (
  <span
    className={`aes-sev-chip ${severity}${cleared ? ' cleared' : ''}`}
    title={title}
  >
    {label ? (
      <>
        <span className='aes-sev-tag'>{AES_SEVERITY_TAG[severity]}</span>
        {label}
      </>
    ) : (
      AES_SEVERITY_LABEL[severity]
    )}
  </span>
);

export default AesSeverityChip;
